import React from 'react';
import classNames from 'classnames';

import styles from './styles.module.scss';

const Navigation = (props) => {
  const {
    navigation = [],
    styleOverride = {
      linkListWrapper: null,
      linkList: null,
      linkListItem: null,
    },
  } = props;

  const wrapperClasses = classNames(
    styles.headerPackageNavigation,
    styleOverride.linkListWrapper,
  );

  if (navigation?.length) {
    return (
      <div className={wrapperClasses}>
        <ul className={styleOverride.linkList}>
          {navigation.map((item) => (
            <li
              key={item.linkTitle}
              className={styleOverride.linkListItem}
            >
              <a href={item.linkUrl}>
                {item.linkTitle}
              </a>
            </li>
          ))}
        </ul>
      </div>
    );
  }
  return null;
};

export default Navigation;
